import _ from 'lodash';
import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from "react-redux";
import { compose } from 'redux';
import { ROUTES } from "../../../commons/routes/routes";
import { consts as cfgConsts, selectors as cfgSelectors } from '../../../redux/modules/configuracoes';
import { actions as flowActions, selectors as flowSelectors } from '../../../redux/modules/flow';
import { actions as userActions, selectors as userSelectors, types as userTypes } from '../../../redux/modules/usuario';
import LoginForm from './containers/LoginForm';

class Login extends PureComponent {

  componentWillMount() {
    if (this.props.isAuthenticated) {
      this.props.history.push(ROUTES.ONBOARDING.path)
    }
  }

  componentWillUnmount() {
    this.props.reset(userTypes.USER_LOGIN);
  }

  render() {
    const { loading, erro, login, openModal, captchaEnabled, captchaSitekey, config } = this.props;
    const redirectUrl = _.get(this.props, 'location.state.redirectUrl');
    const redirecPageDefault = config.exibe_solicitacao ? ROUTES.MINHAS_SOLICITACOES.path : ROUTES.SERVICOS_DISPONIVEIS.path

    return (
      <LoginForm
        loading={loading}
        erro={erro}
        login={login}
        openModal={openModal}
        redirectUrl={redirectUrl}
        captchaEnabled={captchaEnabled}
        redirecPageDefault={redirecPageDefault}
        captchaSitekey={captchaSitekey}

      />
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: flowSelectors.isLoadingByType(state, userTypes.USER_LOGIN),
    erro: flowSelectors.getErrorByType(state, userTypes.USER_LOGIN),
    captchaEnabled: cfgSelectors.getValorConfiguracaoUpperCase(state, cfgConsts.GOOGLE_RECAPTCHA_ENABLED) === 'TRUE',
    captchaSitekey: cfgSelectors.getValorConfiguracao(state, cfgConsts.GOOGLE_RECAPTCHA_SITE_KEY),
    isAuthenticated: userSelectors.isAuthenticated(state),
    config: cfgSelectors.getConfiguracao(state, cfgConsts.APPLICATION_CONFIG_RESOURCES)
  };
}

const mapDispatchToProps = {
  login: userActions.loginUser,
  reset: flowActions.reset,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)(Login);